module.exports = __webpack_public_path__ + "img/vizualizacoes.cf507673.svg";